import { FC, ReactNode } from 'react'
import classNames from 'classnames'
import { Button } from '@/atoms/Button'
import { FlexColumn } from '@/atoms/FlexContainers'
import { useTranslate } from '@/utils/translate/translate-client'
import {
  GButtonMD,
  GResponsiveText,
  GTitleLG,
  GTitleSM,
  GTitleXL,
  GTitleXS,
} from '@/views/PreSales/PreSalesGiveawayView/components/Typography'
import { GiveawayHowToStep } from '@/views/PreSales/PreSalesGiveawayView/hooks/useGiveawayConfigData'

interface Props {
  scrollToProducts: () => void
  steps: GiveawayHowToStep[]
  className?: string
}

export const HowItWorks: FC<Props> = ({ scrollToProducts, steps, className }) => {
  const { t } = useTranslate('tickets')

  return (
    <FlexColumn
      className={classNames('mx-auto max-w-[1080px] gap-4 pb-12 pt-[72px] md:pb-16 md:pt-[120px]', className)}
    >
      <GResponsiveText
        color="giveaway-text-primary-light"
        MobileTextComponent={GTitleLG}
        DesktopTextComponent={GTitleXL}
      >
        {t('howItWorks', 'How it Works')}
      </GResponsiveText>

      {steps.map((step, index) => (
        <StepValue key={step.title} step={(index + 1).toString().padStart(2, '0')}>
          <b>{step.title}:</b> {step.description}
        </StepValue>
      ))}
      <Button
        variant="gray-400"
        className="mt-6 hidden rounded-xl !border-2 !border-giveaway-primary-accent px-[24px] pb-[15px] pt-[14px] !font-['bio-sans'] !text-giveaway-primary-accent md:block md:w-fit"
        outline
        onClick={scrollToProducts}
      >
        <GButtonMD>Pre-Order Tickets</GButtonMD>
      </Button>
    </FlexColumn>
  )
}

const StepValue = ({ step, children }: { step: string; children: ReactNode }) => (
  <div className="mb-4 flex items-start justify-start gap-2">
    <div className="flex rounded bg-giveaway-secondary px-2 pb-0.5 font-['bio-sans'] text-xl font-bold leading-[150%] tracking-wide text-homestead-primary-blue">
      {step}
    </div>
    <GResponsiveText
      color="giveaway-text-primary-light"
      className="!font-normal"
      MobileTextComponent={GTitleXS}
      DesktopTextComponent={GTitleSM}
    >
      {children}
    </GResponsiveText>
  </div>
)
